// extracted by mini-css-extract-plugin
export default {"btn-container":"edit-profile_btn-container__qWFJj"};